// extracted by mini-css-extract-plugin
export default {"root":"JSHTmqGt2D2Pk169JH2A","spacing":"r7rYM94t3y3Pvl101i54","content":"lTGH9lDEpc_NqUzdqIqs","actions":"O3vHwsu1dDZt8h2pMVlG"};